import React from "react";
import { FaWhatsapp, FaEnvelope } from "react-icons/fa";
import "./WhatsAppChat.css";

const WHATSAPP_NUMBER = "918807349930"; // +91-8807349930 without + or spaces
const EMAIL_ADDRESS = "admin@encycdata.com";

const WhatsAppChat = () => {
  const whatsappUrl = `https://wa.me/${WHATSAPP_NUMBER}`;
  const emailUrl = `mailto:${EMAIL_ADDRESS}`;
  return (
    <div className="contact-floats">
      <a
        href={emailUrl}
        className="contact-float email-float"
        aria-label="Email us"
      >
        <FaEnvelope className="contact-float-icon" style={{ color: "#ffffff" }} />
      </a>
      <a
        href={whatsappUrl}
        target="_blank"
        rel="noopener noreferrer"
        className="contact-float whatsapp-float"
        aria-label="Chat on WhatsApp"
      >
        <FaWhatsapp className="contact-float-icon" />
      </a>
    </div>
  );
};

export default WhatsAppChat;
